(() => {
  if (window.K9DrawerPresentation) return;
  const dismissed = new Set();
  const state = { dismissed, observer: null, queued: false, lineIds: null };
  window.K9DrawerPresentation = state;
  const drawer = () => document.querySelector('cart-drawer');
  const setHidden = (node, value) => { if (node.hidden !== value) node.hidden = value; };
  function refreshKlarna(root) {
    const placement = root.querySelector('.k9-cart__klarna');
    if (!placement || root.classList.contains('is-empty')) return;
    const amount = placement.dataset.purchaseAmount;
    if (placement.dataset.k9Amount === amount) return;
    placement.dataset.k9Amount = amount;
    const refresh = () => {
      window.KlarnaOnsiteService = window.KlarnaOnsiteService || [];
      window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' });
    };
    const src = 'https://js.klarna.com/web-sdk/v1/klarna.js';
    let script = [...document.scripts].find(node => node.src === src);
    if (!script) {
      script = document.createElement('script');
      script.id = 'klarna-osm-script-tag';
      script.async = true;
      script.src = src;
      script.dataset.environment = 'production';
      script.dataset.clientId = 'c7a06148-e7a0-503b-8d7f-0fc097bf659a';
      script.addEventListener('load', refresh, { once: true });
      document.body.append(script);
    }
    refresh();
    const fontUrl = 'https://x.klarnacdn.net/onsite-messaging/fonts/v1.2/fonts.css';
    if (![...document.querySelectorAll('link[rel="stylesheet"]')].some(node => node.href === fontUrl)) {
      const link = document.createElement('link');
      link.rel = 'stylesheet'; link.href = fontUrl; document.head.append(link);
    }
  }
  function refresh() {
    state.queued = false;
    const root = drawer(); if (!root) return;
    for (const wrapper of root.querySelectorAll('[data-k9-offer-card]')) {
      const offer = wrapper.querySelector('k9-patch-offer,k9-bogo-offer');
      setHidden(wrapper, dismissed.has(wrapper.dataset.k9OfferHandle) || !offer || offer.hidden);
    }
    // Lot 5: at most 3 recommendations in rank (DOM) order; pending or closed cards keep their place, failed ones free it.
    let places = 0;
    for (const reco of root.querySelectorAll('[data-k9-reco]')) {
      const offer = reco.querySelector('k9-patch-offer,k9-bogo-offer');
      const closer = reco.querySelector('[data-k9-offer-card]');
      const closed = Boolean(closer && dismissed.has(closer.dataset.k9OfferHandle));
      const failed = !offer || offer.dataset.k9Devis === 'echec';
      const counts = (closed || !failed) && places++ < 3;
      setHidden(reco, !counts || closed || failed || offer.hidden);
    }
    const section = root.querySelector('[data-k9-recommendations]');
    if (section) {
      const children = [...section.querySelector('.k9-cart__offers').children];
      setHidden(section, !children.some(node => !node.hidden && !['SCRIPT','STYLE'].includes(node.tagName)));
    }
    const lines = [...root.querySelectorAll('.k9-cart-line[data-k9-variant]')];
    const ids = new Set(lines.map(line => line.dataset.k9Variant));
    if (state.lineIds) {
      for (const line of lines) if (!state.lineIds.has(line.dataset.k9Variant)) {
        line.classList.add('k9-cart-line--added');
        line.addEventListener('animationend', () => line.classList.remove('k9-cart-line--added'), { once: true });
      }
    }
    state.lineIds = ids;
    refreshKlarna(root);
    // Lot 4: callbacks run once the drawer content is final (the measurement re-observes cards); never break refresh.
    for (const hook of window.K9DrawerHooks || []) { try { hook(root); } catch { /* measurement only */ } }
  }
  const schedule = () => {
    if (state.queued) return;
    state.queued = true; requestAnimationFrame(refresh);
  };
  function connect() {
    const root = drawer(); if (!root || state.observer) return;
    state.observer = new MutationObserver(schedule);
    state.observer.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden', 'data-k9-devis'] });
    // Opening the Patch form moves keyboard focus to the required name.
    root.addEventListener('toggle', event => {
      const details = event.target;
      if (!details.matches?.('details.k9-patch-offer__options')) return;
      const restored = 'k9Restored' in details.dataset; delete details.dataset.k9Restored;
      if (details.open && !restored) {
        details.querySelector('input[data-field="name"]')?.focus();
      }
    }, true);
    root.addEventListener('click', event => {
      const button = event.target.closest('[data-k9-dismiss-offer]');
      if (!button) return;
      const wrapper = button.closest('[data-k9-offer-card]'); if (!wrapper) return;
      event.preventDefault();
      dismissed.add(wrapper.dataset.k9OfferHandle);
      setHidden(wrapper, true);
      refresh();
      // Next visible recommendation after the closed one (then before it), else the checkout button.
      const recos = [...root.querySelectorAll('[data-k9-reco]')], from = recos.indexOf(wrapper.closest('[data-k9-reco]'));
      const next = [...recos.slice(from + 1), ...recos.slice(0, Math.max(from, 0))].find(node => !node.hidden)
        || [...root.querySelectorAll('[data-k9-offer-card]')].find(node => !node.closest('[hidden]'));
      const target = [...(next?.querySelectorAll('summary,button:not([data-k9-dismiss-offer]):not([disabled]),a,input,select') || [])]
        .find(node => !node.closest('[hidden]'))
        || root.querySelector('#CartDrawer-Checkout');
      target?.focus({ preventScroll: true });
    });
    refresh();
  }
  // « Guide des tailles » of the drawer's Modifier panel opens the product page at #guide-des-tailles. The guide is the
  // GemPages block details.k9-size-guide; its inline script keeps its own toggle in sync on « toggle ». Scrolled into
  // view once the page has loaded, so images above it do not move it away.
  function openSizeGuide() {
    if (location.hash !== '#guide-des-tailles') return;
    const guide = document.querySelector('details.k9-size-guide');
    if (!guide) return;
    guide.open = true;
    const show = () => (document.querySelector('.k9-size-guide__toggle') || guide).scrollIntoView({ block: 'center' });
    if (document.readyState === 'complete') show();
    else window.addEventListener('load', show, { once: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => { connect(); openSizeGuide(); }, { once: true });
  else { connect(); openSizeGuide(); }
})();
